const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validatePhone = (number) => {
  const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
  return re.test(String(number).toLowerCase());
};

const formValidationCheck = (formData, setValidationCheck) => {
  const {
    status,
    progressLevel,
    registerForIntercession,
    previouslyEnrolled,
    firstName,
    middleName,
    lastName,
    haveSuffix,
    suffix,
    gender,
    birthDate,
    gradeLevel,
    age,
    birthState,
    birthCountry,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgHighestLevelOfEducation,
    permissionParentContact,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    pgPrimaryEmail,
    liveWithPg,
    livingStatus,
    street,
    city,
    state,
    zip,
    county,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    isStudentHispanicOrLatino,
    primaryRaceCategory,
    previousSchool,
    previousSchoolCity,
    previousSchoolState,
    primaryLanguage,
    firstLanguage,
    homeLanguage,
    languageSpokenByParentsToStudent,
    languageSpokenByAdultsAtHome,
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
    releaseAudioAndVideo,
    releasePermissionForSocialMedia,
    releaseUseStudentWork,
    releasePermissionToTextStudent,
    releasePermissionToTextPg,
    releaseAllowStudentAccessToGoogleAppsForEducation,
    beenExpelled,
    expelledFromWhichSchool,
    expelledWhatYear,
    beenSuspended,
    suspendedFromWhichSchool,
    suspendedWhatYear,
    onProbation,
    isParentOrExpecting,
    moreThanThreeUnexcusedAbsences,
    lateToSchoolMoreThanThreeTimes,
    orderedToAttendSchool,
    orderedToAttendWhichSchool,
    orderedToAttendWhatYear,
    retainedMoreThanOnce,
    retainedFromWhichSchool,
    retainedFromWhatYear,
    droppedOutOfSchool,
    droppedOutFromWhichSchool,
    droppedOutFromWhatYear,
    behindSemesterInCredits,
    outOfSchoolMoreThanFortyFiveDays,
    expelledMoreThanTwoSchoolsPastYear,
    fosterCare,
    youthExperiencingHomelessness,
    accessToComputerAtHome,
    accessToTheInternetAtHome,
    knownHealthConditions,
    asthma,
    beeStingAllergy,
    diabetes,
    epilepsy,
    heartCondition,
    seizures,
    nutAllergy,
    knownHearingConditions,
    wearsHearingAid,
    knownEyeCondition,
    glassesToBeWornAtAllTimes,
    wearsContactLenses,
    wearsGlasses,
    custodyIssueExists,
    legalRestrictionsForAnyParent,
    emergencyContact1FirstName,
    emergencyContact1LastName,
    emergencyContact1Phone,
    emergencyContact1Relationship,
    authorizedForPickup1,
    emergencyContact2FirstName,
    emergencyContact2LastName,
    emergencyContact2Phone,
    emergencyContact2Relationship,
    authorizedForPickup2,
    learningCenterId,
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
    learningCenterCoordinates,
  } = formData;

  const locationCheck =
    learningCenterName !== "" &&
    learningCenterCharter !== "" &&
    learningCenterAddress !== "";
  // 1. Enrollment Type Check
  const enrollmentCheck = previouslyEnrolled !== "";
  // 2. Student Information Check
  const studentCheck =
    firstName !== "" &&
    lastName !== "" &&
    (registerForIntercession ||
      (!registerForIntercession &&
        ((haveSuffix["yes"] && suffix !== "") || haveSuffix["no"]))) &&
    gender !== "" &&
    birthDate !== "" &&
    ((registerForIntercession && gradeLevel !== "") ||
      !registerForIntercession) &&
    age > 0 &&
    (registerForIntercession ||
      (!registerForIntercession && birthState !== "" && birthCountry !== "")) &&
    studentEmail !== "" &&
    validateEmail(studentEmail) &&
    studentPrimaryPhone !== "" &&
    validatePhone(studentPrimaryPhone) &&
    studentPrimaryPhoneType !== "";
  // 3. Parent Information Check
  const parentInfo =
    pgRelationshipToStudent !== "" &&
    pgFirstName !== "" &&
    pgLastName !== "" &&
    pgPrimaryPhone !== "" &&
    pgPrimaryPhoneType !== "" &&
    validatePhone(pgPrimaryPhone) &&
    pgPrimaryEmail !== "" &&
    validateEmail(pgPrimaryEmail);
  const parentCheck =
    ((!registerForIntercession && pgHighestLevelOfEducation !== "") ||
      registerForIntercession) &&
    ((age < 18 && parentInfo) ||
      (age >= 18 &&
        ((permissionParentContact["yes"] && parentInfo) ||
          permissionParentContact["no"])));
  // 4. Physical Address Check
  const physicalCheck =
    ((!registerForIntercession && (liveWithPg["yes"] || liveWithPg["no"])) ||
      registerForIntercession) &&
    livingStatus !== "" &&
    street !== "" &&
    city !== "" &&
    state !== "" &&
    zip !== "" &&
    county !== "" &&
    (isMailingAddressTheSame["yes"] || isMailingAddressTheSame["no"]);
  // 5. Mailing Address Check
  const mailingCheck =
    (isMailingAddressTheSame["no"] &&
      mailingStreet !== "" &&
      mailingCity !== "" &&
      mailingState !== "" &&
      mailingZip !== "") ||
    isMailingAddressTheSame["yes"];
  // 6. Ethnicity Check
  const ethnicityCheck =
    (isStudentHispanicOrLatino["yes"] || isStudentHispanicOrLatino["no"]) &&
    primaryRaceCategory !== "";
  // 7. Previous School Check
  const previousCheck =
    previousSchool !== "" &&
    previousSchoolState !== "" &&
    previousSchoolCity !== "";
  // 8. Primary Language Check
  const primaryLanguageCheck = primaryLanguage !== "";
  // 9. Home Language Check
  const homeLanguageCheck =
    firstLanguage !== "" &&
    homeLanguage !== "" &&
    languageSpokenByParentsToStudent !== "" &&
    languageSpokenByAdultsAtHome !== "";
  // 10. Migrant Check
  const migrantCheck =
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["yes"] ||
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["no"];
  // 11. Release Request Check
  const releaseCheck =
    (releaseAudioAndVideo["yes"] || releaseAudioAndVideo["no"]) &&
    (releasePermissionForSocialMedia["yes"] ||
      releasePermissionForSocialMedia["no"]) &&
    (releaseUseStudentWork["yes"] || releaseUseStudentWork["no"]) &&
    (releasePermissionToTextStudent["yes"] ||
      releasePermissionToTextStudent["no"]) &&
    (releasePermissionToTextPg["yes"] || releasePermissionToTextPg["no"]) &&
    (releaseAllowStudentAccessToGoogleAppsForEducation["yes"] ||
      releaseAllowStudentAccessToGoogleAppsForEducation["no"]);
  // 12. Dass Information Check
  const dassCheck =
    (onProbation["yes"] || onProbation["no"]) &&
    (isParentOrExpecting["yes"] || isParentOrExpecting["no"]) &&
    (moreThanThreeUnexcusedAbsences["yes"] ||
      moreThanThreeUnexcusedAbsences["no"]) &&
    (lateToSchoolMoreThanThreeTimes["yes"] ||
      lateToSchoolMoreThanThreeTimes["no"]) &&
    (behindSemesterInCredits["yes"] || behindSemesterInCredits["no"]) &&
    (outOfSchoolMoreThanFortyFiveDays["yes"] ||
      outOfSchoolMoreThanFortyFiveDays["no"]) &&
    (expelledMoreThanTwoSchoolsPastYear["yes"] ||
      expelledMoreThanTwoSchoolsPastYear["no"]) &&
    (fosterCare["yes"] || fosterCare["no"]) &&
    (youthExperiencingHomelessness["yes"] ||
      youthExperiencingHomelessness["no"]) &&
    (beenExpelled["no"] ||
      (expelledFromWhichSchool !== "" &&
        expelledWhatYear !== "" &&
        beenExpelled["yes"])) &&
    (beenSuspended["no"] ||
      (suspendedFromWhichSchool !== "" &&
        suspendedWhatYear !== "" &&
        beenSuspended["yes"])) &&
    (orderedToAttendSchool["no"] ||
      (orderedToAttendWhichSchool !== "" &&
        orderedToAttendWhatYear !== "" &&
        orderedToAttendSchool["yes"])) &&
    (retainedMoreThanOnce["no"] ||
      (retainedFromWhichSchool !== "" &&
        retainedFromWhatYear !== "" &&
        retainedMoreThanOnce["yes"])) &&
    (droppedOutOfSchool["no"] ||
      (droppedOutFromWhichSchool !== "" &&
        droppedOutFromWhatYear !== "" &&
        droppedOutOfSchool["yes"]));
  // 13. Home Survey Check
  const homeSurveyCheck =
    (accessToComputerAtHome["yes"] || accessToComputerAtHome["no"]) &&
    (accessToTheInternetAtHome["yes"] || accessToTheInternetAtHome["no"]);
  // 14. Health Conditions Check
  const healthCheck =
    ((knownHealthConditions["yes"] &&
      (asthma["yes"] || asthma["no"]) &&
      (beeStingAllergy["yes"] || beeStingAllergy["no"]) &&
      (diabetes["yes"] || diabetes["no"]) &&
      (epilepsy["yes"] || epilepsy["no"]) &&
      (heartCondition["yes"] || heartCondition["no"]) &&
      (seizures["yes"] || seizures["no"]) &&
      (nutAllergy["yes"] || nutAllergy["no"])) ||
      knownHealthConditions["no"]) &&
    ((knownHearingConditions["yes"] &&
      (wearsHearingAid["yes"] || wearsHearingAid["no"])) ||
      knownHearingConditions["no"]) &&
    (knownEyeCondition["no"] ||
      (knownEyeCondition["yes"] &&
        (glassesToBeWornAtAllTimes["yes"] || glassesToBeWornAtAllTimes["no"]) &&
        (wearsContactLenses["yes"] || wearsContactLenses["no"]) &&
        (wearsGlasses["yes"] || wearsGlasses["no"])));

  // 15. Parent Custody Check
  const custodyCheck =
    (custodyIssueExists["yes"] || custodyIssueExists["no"]) &&
    (legalRestrictionsForAnyParent["yes"] ||
      legalRestrictionsForAnyParent["no"]);
  // 16. Emergency Contacts Check
  const emergencyCheck =
    emergencyContact1FirstName !== "" &&
    emergencyContact1LastName !== "" &&
    emergencyContact1Phone !== "" &&
    validatePhone(emergencyContact1Phone) &&
    emergencyContact1Relationship !== "" &&
    (authorizedForPickup1["yes"] || authorizedForPickup1["no"]) &&
    emergencyContact2FirstName !== "" &&
    emergencyContact2LastName !== "" &&
    emergencyContact2Phone !== "" &&
    validatePhone(emergencyContact2Phone) &&
    emergencyContact2Relationship !== "" &&
    (authorizedForPickup2["yes"] || authorizedForPickup2["no"]);

  const checkValue =
    locationCheck &&
    // enrollmentCheck &&
    studentCheck &&
    parentCheck &&
    physicalCheck &&
    mailingCheck &&
    (registerForIntercession ||
      (!registerForIntercession &&
        ethnicityCheck &&
        previousCheck &&
        primaryLanguageCheck &&
        homeLanguageCheck &&
        migrantCheck &&
        releaseCheck &&
        dassCheck &&
        homeSurveyCheck &&
        healthCheck &&
        custodyCheck &&
        emergencyCheck));
  setValidationCheck(!checkValue);
  return !checkValue;
};

export default formValidationCheck;
